export const isCssVariable = (value: string): boolean =>
  value?.startsWith("var(") ?? false;
